import { Modal } from "antd"
import React from "react"

export const PolicyRenewalChangeConfirmation: React.FunctionComponent<IPolicyRenewalChangeConfirmationProps> =
  ({ isVisible, text: selectedOptionText, onConfirm, onCancel, isLoading }) => {
    const handleCancel = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
      onCancel(e)
    }

    return (
      <Modal
        title="Confirm Renewal Status Change"
        centered
        destroyOnClose
        visible={isVisible}
        onCancel={handleCancel}
        okText="Confirm"
        onOk={onConfirm}
        confirmLoading={isLoading}
      >
        <p>{selectedOptionText}</p>
      </Modal>
    )
  }

export interface IPolicyRenewalChangeConfirmationProps {
  isVisible: boolean
  text: string
  onConfirm: VoidFunction
  onCancel: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void
  isLoading: boolean
}
